<div class="sample-status-widget">
  @if (widgetTitle) {
    <div class="widget-title-header">
      <h4 class="widget-title">{{ titleMeta.isCustom ? widgetTitle : (widgetTitle | translate) }}{{ titleMeta.tailPrefix }}{{ titleMeta.tailKey | translate }}{{ titleMeta.tail }}</h4>
    </div>
  }
  @if (widgetTitle) {
    <hr class="widget-divider" />
  }

  <div class="filter-bar">
    <app-sample-status-filters
      [compact]="true"
      [values]="tempFilterValues"
      (filterChange)="onFilterChange($event)"
      >
      <app-widget-org-filter filterAppend
        [orgLevelId]="orgLevelOverrideId"
        (orgLevelIdChange)="onOrgLevelOverrideChange($event)">
      </app-widget-org-filter>
    </app-sample-status-filters>
  </div>

  <div class="widget-content">
    @if (isLoading) {
      <div class="loading-container">
        <div class="loading-spinner"></div>
      </div>
    }

    @if (error && !isLoading) {
      <div class="error-container">
        <mat-icon>error_outline</mat-icon>
        <span>{{ error | translate }}</span>
      </div>
    }

    @if (!isLoading && !error) {
      <div
        class="status-grid"
        [ngClass]="digitsClass"
        >
        @for (item of statusItems; track trackByStatus($index, item)) {
          <div
            class="status-card clickable"
            [matTooltip]="(item.label | translate) + ': ' + item.count"
            matTooltipPosition="above"
            [matTooltipShowDelay]="500"
            [style.background-color]="item.color"
            [style.border-left-color]="item.color"
            role="button"
            tabindex="0"
            (click)="navigateToSamplesByStatus(item.status)"
            (keydown.enter)="navigateToSamplesByStatus(item.status)"
                (keydown.space)="
                    navigateToSamplesByStatus(item.status);
                    $event.preventDefault()
                "
            >
            <div class="status-label">{{ item.label | translate }}</div>
            <div class="status-count">{{ item.count }}</div>
          </div>
        }
      </div>
    }

    @if (!isLoading && !error) {
      <div class="view-all-container">
        <a class="view-all-link" (click)="navigateToSamples()">{{
          "View All Samples" | translate
        }}</a>
      </div>
    }
  </div>
</div>
